import { createContext } from 'react';
import { LocationFormContextValue } from './types';

export const LocationFormContext = createContext<LocationFormContextValue>({
  dirty: {},
  errors: {},
  values: {},
  setDirty: () => null,
  setError: () => null,
  setValues: () => null,
  disabled: false,
  getGeometricConfigEnabled: () => false,
});
